(function () {
  function getWreckerGalleryRoot() {
    return document.querySelector('[data-wrecker-gallery]');
  }

  function getMediaGallery() {
    const root = getWreckerGalleryRoot();
    return root?.querySelector('media-gallery') || null;
  }

  function getActiveMainIndex(mediaGallery) {
    const mains = [...mediaGallery.elements.mains];
    let index = mains.findIndex((el) => el.classList.contains('is-active'));
    if (index < 0 && mediaGallery.flickity) {
      index = mediaGallery.flickity.selectedIndex;
    }
    return { mains, index: Math.max(0, index) };
  }

  function updateGalleryCounter(mediaGallery) {
    const root = getWreckerGalleryRoot();
    const counter = root?.querySelector('[data-wrecker-gallery-counter]');
    if (!counter || !mediaGallery) return;

    const total = parseInt(root.dataset.mediaCount, 10) || mediaGallery.elements.mains.length;
    const { index } = getActiveMainIndex(mediaGallery);
    counter.textContent = index + 1 + ' / ' + total;
  }

  function stepGallery(direction) {
    const mediaGallery = getMediaGallery();
    if (!mediaGallery?.elements?.mains?.length) return;

    const { mains, index } = getActiveMainIndex(mediaGallery);
    const nextIndex = (index + direction + mains.length) % mains.length;
    const mediaId = mains[nextIndex]?.dataset?.mediaId;
    if (!mediaId) return;

    if (typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(mediaId, false);
    } else {
      const thumb = [...mediaGallery.elements.thumbnails].find(
        (el) => el.dataset.mediaId === mediaId,
      );
      thumb?.querySelector('button')?.click();
    }

    window.setTimeout(() => updateGalleryCounter(mediaGallery), 50);
  }

  function bindGalleryControls(mediaGallery) {
    const root = getWreckerGalleryRoot();
    if (!root || !mediaGallery) return;

    const prevBtn = root.querySelector('[data-wrecker-gallery-prev]');
    const nextBtn = root.querySelector('[data-wrecker-gallery-next]');

    prevBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      stepGallery(-1);
    });

    nextBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      stepGallery(1);
    });

    mediaGallery.elements.thumbnails.forEach((thumbnail) => {
      const btn = thumbnail.querySelector('button');
      btn?.addEventListener('click', () => {
        window.setTimeout(() => updateGalleryCounter(mediaGallery), 50);
      });
    });

    if (mediaGallery.flickity) {
      mediaGallery.flickity.on('change', () => updateGalleryCounter(mediaGallery));
    }

    updateGalleryCounter(mediaGallery);
  }

  function initGallery() {
    const tryBind = () => {
      const mediaGallery = getMediaGallery();
      if (!mediaGallery?.elements?.mains?.length) return false;
      bindGalleryControls(mediaGallery);
      return true;
    };

    if (tryBind()) return;

    const interval = window.setInterval(() => {
      if (tryBind()) window.clearInterval(interval);
    }, 100);

    window.setTimeout(() => window.clearInterval(interval), 8000);
  }

  function initPhotosModal() {
    const modal = document.querySelector('[data-wrecker-photos-modal]');
    const openBtn = document.querySelector('[data-wrecker-photos-open]');
    if (!modal || !openBtn) return;

    const slides = [...modal.querySelectorAll('.wrecker-photos-modal__slide')];
    const thumbs = [...modal.querySelectorAll('[data-wrecker-modal-thumb]')];
    const counter = modal.querySelector('[data-wrecker-modal-counter]');
    const prevBtn = modal.querySelector('[data-wrecker-modal-prev]');
    const nextBtn = modal.querySelector('[data-wrecker-modal-next]');
    let index = 0;
    let touchStartX = 0;

    function setSlide(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === index));
      thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === index));
      if (counter) counter.textContent = index + 1 + ' / ' + slides.length;
    }

    function openModal(startIndex) {
      setSlide(startIndex || 0);
      modal.hidden = false;
      document.body.classList.add('wrecker-photos-open');
      modal.querySelector('.wrecker-photos-modal__close')?.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('wrecker-photos-open');
      openBtn.focus();
    }

    function openFromGallery() {
      const mediaGallery = getMediaGallery();
      let start = 0;
      if (mediaGallery) {
        const { index: activeIndex } = getActiveMainIndex(mediaGallery);
        start = activeIndex;
      }
      openModal(start);
    }

    openBtn.addEventListener('click', openFromGallery);

    const galleryWrap = getWreckerGalleryRoot();
    if (galleryWrap) {
      galleryWrap.addEventListener('click', (e) => {
        if (e.target.closest('[data-wrecker-gallery-prev], [data-wrecker-gallery-next]')) return;
        if (
          e.target.closest('.product-media-main img, .product-media-main .aspect-ratio') &&
          !e.target.closest('product-modal, .product-media-modal')
        ) {
          e.preventDefault();
          e.stopPropagation();
          openFromGallery();
        }
      });
    }

    modal.querySelectorAll('[data-wrecker-photos-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    prevBtn?.addEventListener('click', () => setSlide(index - 1));
    nextBtn?.addEventListener('click', () => setSlide(index + 1));

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setSlide(parseInt(thumb.dataset.wreckerModalThumb, 10));
      });
    });

    const main = modal.querySelector('[data-wrecker-modal-carousel]');
    if (main) {
      main.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true },
      );
      main.addEventListener(
        'touchend',
        (e) => {
          const diff = e.changedTouches[0].screenX - touchStartX;
          if (Math.abs(diff) > 50) {
            setSlide(diff < 0 ? index + 1 : index - 1);
          }
        },
        { passive: true },
      );
    }

    document.addEventListener('keydown', (e) => {
      if (modal.hidden) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') setSlide(index - 1);
      if (e.key === 'ArrowRight') setSlide(index + 1);
    });
  }

  function initTabs() {
    const root = document.querySelector('[data-wrecker-tabs]');
    if (!root) return;

    const buttons = [...root.querySelectorAll('[data-wrecker-tab]')];
    const panels = [...root.querySelectorAll('[data-wrecker-panel]')];

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.wreckerTab;
        buttons.forEach((b) => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const active = panel.dataset.wreckerPanel === id;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  function initMobileCta() {
    const bar = document.querySelector('[data-wrecker-mobile-cta]');
    const summary = document.querySelector('[data-wrecker-summary]');
    if (!bar || !summary) return;

    const mq = window.matchMedia('(max-width: 989px)');

    function update() {
      if (!mq.matches) {
        bar.hidden = true;
        return;
      }
      const rect = summary.getBoundingClientRect();
      bar.hidden = rect.bottom > window.innerHeight - 8;
    }

    bar.hidden = false;
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function toSentenceCaseLine(text) {
    const trimmed = (text || '').trim().toLowerCase();
    if (!trimmed) return trimmed;
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
  }

  function escapeHtml(text) {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function applySentenceCaseToContainer(container) {
    if (container.dataset.lineCased === 'true') return;

    const existingLines = container.querySelectorAll('.wrecker-line');
    if (existingLines.length) {
      existingLines.forEach((el) => {
        el.textContent = toSentenceCaseLine(el.textContent);
      });
      container.dataset.lineCased = 'true';
      return;
    }

    const blocks = container.querySelectorAll('p, li');
    if (blocks.length) {
      blocks.forEach((el) => {
        el.textContent = toSentenceCaseLine(el.textContent);
      });
      container.dataset.lineCased = 'true';
      return;
    }

    const raw = (container.textContent || '').trim();
    if (!raw) return;

    const lines = raw.split(/\r?\n+/).map((line) => line.trim()).filter(Boolean);
    const lineTexts = lines.length ? lines : [raw];

    container.innerHTML = lineTexts
      .map((line) => `<p class="wrecker-line">${escapeHtml(toSentenceCaseLine(line))}</p>`)
      .join('');

    container.dataset.lineCased = 'true';
  }

  function initLineSentenceCase() {
    document.querySelectorAll('[data-wrecker-info-sentence-case]').forEach(applySentenceCaseToContainer);
    document.querySelectorAll('[data-wrecker-description-sentence-case]').forEach(applySentenceCaseToContainer);
    document.querySelectorAll('[data-wrecker-line-sentence-case]').forEach(applySentenceCaseToContainer);
  }

  function init() {
    initGallery();
    initPhotosModal();
    initTabs();
    initMobileCta();
    initLineSentenceCase();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
